import { useMemo } from 'react';
import classnames from 'classnames';

import styles from './Avatar.module.scss';

const EMPTY_AVATAR = '/static/images/empty-avatar.svg';

interface Props {
  alt?: string;
  avatar?: string;
  classes?: Parameters<typeof classnames['default']>[0] | Parameters<typeof classnames['default']>;
  height?: number;
  width?: number;
}

const Avatar: React.FC<Props> = ({ alt, avatar, height, width, classes }) => {
  const src = useMemo(() => {
    if (!avatar) {
      return EMPTY_AVATAR;
    }
    return avatar;
  }, [avatar]);
  return (
    <img
      alt={alt}
      className={classnames(styles.avatar, classes)}
      src={src}
      height={height}
      width={width}
    />
  );
};

export type { Props };
export default Avatar;
